import {Pipe, PipeTransform} from "@angular/core";
import {FormatTimepointPipe} from "../format/format-timepoint.pipe";
import {onlyUnique} from "../../functions/meta.functions";
import {GrundbuchgeschaeftRestListEntryMeta} from "../../../core/gb-api";
import {ComparatorService} from "../../services/comparator-service";

@Pipe({
  name: 'orderByGbGeschaeft'
})
export class OrderByGbGeschaeftPipe implements PipeTransform {

  public constructor(private formatTimepointPipe: FormatTimepointPipe,
                     private comparatorService: ComparatorService) {
  }

  transform(array, ascending = true) {
    if (!array) {
      return;
    }
    if (ascending) {
      return Array.from(array).filter(onlyUnique).sort((item1: any, item2: any) => {
        return this.orderByGeschaeft(item1, item2);
      });
    } else {
      return Array.from(array).filter(onlyUnique).sort((item1: any, item2: any) => {
        return this.orderByGeschaeft(item2, item1);
      });
    }
  }

  orderByGeschaeft(a: GrundbuchgeschaeftRestListEntryMeta ,
                   b: GrundbuchgeschaeftRestListEntryMeta ): number {
    const ggA: GrundbuchgeschaeftRestListEntryMeta = <GrundbuchgeschaeftRestListEntryMeta>a;
    const ggB: GrundbuchgeschaeftRestListEntryMeta = <GrundbuchgeschaeftRestListEntryMeta>b;
    return this.comparatorService.orderByComparator(this.formatTimepointPipe.transform(ggA.timePoint), this.formatTimepointPipe.transform(ggB.timePoint));
  }

}
